import React from 'react';
import { Grid, Box, Typography, Checkbox } from '@mui/material';
import { getStatusColors } from '../../helpers/statusColors';

interface CalendarLegendProps {
  role?: string;
  approverLevel?: number;
  handleCheckboxChange: (name: any) => void;
  flexItemLeft: React.CSSProperties;
}

export const CalendarLegend = ({ 
  role, 
  approverLevel, 
  handleCheckboxChange, 
  flexItemLeft 
}: CalendarLegendProps) => {
  return (
    <Grid
      item
      sm={6}
      md={6}
      lg={12}
      sx={{
        justifyContent: { sm: 'flex-start', md: 'flex-start' }
      }}
    >
      <Box>
        <Typography
          align='left'
          sx={{ fontSize: '16px', fontWeight: 700 }}
        >
          Legend
        </Typography>

        {/* Draft (stored as SAVED) */}
        {role !== undefined && (
          <Box style={flexItemLeft}>
            <Checkbox
              size='small'
              defaultChecked={!(approverLevel === 1 || approverLevel === 2 || approverLevel === 3)}
              style={{ color: getStatusColors('SAVED').backgroundColor }}
              name='SAVED'
              onChange={name => handleCheckboxChange(name)}
            />
            <span>{getStatusColors('SAVED').label}</span>
          </Box>
        )}

        {/* Approvers */}
        {role !== undefined && (
          <>
            {role === 'ADMIN' || role === 'APPROVER' ? (
              <>
                <div style={flexItemLeft}>
                  <Checkbox
                    size='small'
                    defaultChecked={!(approverLevel === 2 || approverLevel === 3)}
                    name='APPROVAL1'
                    onChange={name => handleCheckboxChange(name)}
                    style={{ color: getStatusColors('APPROVAL1').backgroundColor }}
                  />
                  <span>{getStatusColors('APPROVAL1').label}</span>
                </div>
                <div style={flexItemLeft}>
                  <Checkbox
                    size='small'
                    defaultChecked={!(approverLevel === 1 || approverLevel === 3)}
                    name='APPROVAL2'
                    onChange={name => handleCheckboxChange(name)}
                    style={{ color: getStatusColors('APPROVAL2').backgroundColor }}
                  />
                  <span>{getStatusColors('APPROVAL2').label}</span>
                </div>
                <div style={flexItemLeft}>
                  <Checkbox
                    size='small'
                    defaultChecked={!(approverLevel === 1 || approverLevel === 2)}
                    name='APPROVAL3'
                    style={{ color: getStatusColors('APPROVAL3').backgroundColor }}
                    onChange={name => handleCheckboxChange(name)}
                  />
                  <span>{getStatusColors('APPROVAL3').label}</span>
                </div>
              </>
            ) : (
              <div style={flexItemLeft}>
                <Checkbox
                  size='small'
                  defaultChecked
                  name='APPROVAL_PENDING'
                  onChange={name => handleCheckboxChange(name)}
                  style={{ color: getStatusColors('APPROVAL_PENDING').backgroundColor }}
                />
                <span>{getStatusColors('APPROVAL_PENDING').label}</span>
              </div>
            )}
          </>
        )}

        {/* Approved And Booked */}
        {role !== undefined && (
          <Box style={flexItemLeft}>
            <Checkbox
              size='small'
              defaultChecked={!(approverLevel === 1 || approverLevel === 2 || approverLevel === 3)}
              name='APPROVED'
              color='success'
              onChange={name => handleCheckboxChange(name)}
            />
            <span>{getStatusColors('APPROVED').label}</span>
          </Box>
        )}

        {/* Dry Run */}
        {role !== undefined && (
          <Box style={flexItemLeft}>
            <Checkbox
              size='small'
              defaultChecked={!(approverLevel === 1 || approverLevel === 2 || approverLevel === 3)}
              name='DRY'
              style={{ color: getStatusColors('DRY').backgroundColor }}
              onChange={name => handleCheckboxChange(name)}
            />
            <span>{getStatusColors('DRY').label}</span>
          </Box>
        )}

        {/* Unavailable / Blocked */}
        <Box style={flexItemLeft}>
          <Checkbox
            size='small'
            defaultChecked={!(approverLevel === 1 || approverLevel === 2 || approverLevel === 3)}
            name='BLOCKED'
            style={{ color: getStatusColors('BLOCKED').backgroundColor }}
            onChange={name => handleCheckboxChange(name)}
          />
          <span>{getStatusColors('BLOCKED').label}</span>
        </Box>
      </Box>
    </Grid>
  );
};

export default CalendarLegend; 